// Mock data + pricing engine for ROLVIA DESIGN
// Order: SLA -> SLS -> FDM

export const TECHNOLOGIES = [
  { id: 'sla', label: 'SLA' },
  { id: 'sls', label: 'SLS' },
  { id: 'fdm', label: 'FDM' }
];

export const MATERIALS = {
  sla: [
    { id: 'standard', label: 'Standart Reçine', pricePerCm3: 2.20, colors: ['Gri', 'Siyah', 'Beyaz'] },
    { id: 'tough',    label: 'Tough Reçine',    pricePerCm3: 3.10, colors: ['Gri', 'Siyah'] },
    { id: 'clear',    label: 'Clear (Şeffaf)',  pricePerCm3: 3.40, colors: ['Şeffaf'] },
    { id: 'dental',   label: 'Dental Reçine',   pricePerCm3: 5.20, colors: ['Bej'] },
    { id: 'castable', label: 'Castable',        pricePerCm3: 6.10, colors: ['Mor'] }
  ],
  sls: [
    { id: 'pa12',       label: 'PA12 (Naylon)',        pricePerCm3: 3.80, colors: ['Doğal', 'Siyah'] },
    { id: 'pa11',       label: 'PA11 (Naylon)',        pricePerCm3: 4.60, colors: ['Doğal', 'Siyah'] },
    { id: 'pa12_gf',    label: 'PA12 GF (Cam Takviyeli)', pricePerCm3: 5.20, colors: ['Gri'] },
    { id: 'tpu_sls',    label: 'TPU (Esnek)',          pricePerCm3: 6.80, colors: ['Doğal'] },
    { id: 'pa_alu',     label: 'PA Alüminyum Dolgulu', pricePerCm3: 7.40, colors: ['Gri'] }
  ],
  fdm: [
    { id: 'pla',  label: 'PLA',  pricePerCm3: 0.85, colors: ['Siyah', 'Beyaz', 'Turuncu', 'Gri', 'Kırmızı', 'Mavi', 'Yeşil'] },
    { id: 'petg', label: 'PETG', pricePerCm3: 1.10, colors: ['Siyah', 'Beyaz', 'Turuncu', 'Şeffaf'] },
    { id: 'abs',  label: 'ABS',  pricePerCm3: 1.20, colors: ['Siyah', 'Beyaz', 'Gri'] },
    { id: 'asa',  label: 'ASA',  pricePerCm3: 1.40, colors: ['Siyah', 'Beyaz'] },
    { id: 'tpu',  label: 'TPU (Esnek)', pricePerCm3: 1.80, colors: ['Siyah', 'Beyaz', 'Turuncu'] },
    { id: 'nylon',label: 'Naylon', pricePerCm3: 2.30, colors: ['Siyah', 'Beyaz'] }
  ]
};

export const LAYER_HEIGHTS = {
  sla: [
    { id: 0.10,  label: '0.10 mm (Hızlı)',    multiplier: 0.9 },
    { id: 0.05,  label: '0.05 mm (Standart)', multiplier: 1.0 },
    { id: 0.025, label: '0.025 mm (Ultra Detay)', multiplier: 1.4 }
  ],
  sls: [
    { id: 0.12, label: '0.12 mm (Standart)', multiplier: 1.0 },
    { id: 0.10, label: '0.10 mm (Detaylı)',  multiplier: 1.20 }
  ],
  fdm: [
    { id: 0.30, label: '0.30 mm (Hızlı)', multiplier: 0.85 },
    { id: 0.20, label: '0.20 mm (Standart)', multiplier: 1.0 },
    { id: 0.15, label: '0.15 mm (Detaylı)', multiplier: 1.25 },
    { id: 0.10, label: '0.10 mm (Yüksek Detay)', multiplier: 1.55 }
  ]
};

export const INFILL_OPTIONS = [10, 20, 30, 50, 75, 100];

export const FINISH_OPTIONS = [
  { id: 'none',      label: 'none',           multiplier: 1.0 },
  { id: 'standard',  label: 'standard',       multiplier: 1.05 },
  { id: 'support',   label: 'supportRemoval', multiplier: 1.10 },
  { id: 'polishing', label: 'polishing',      multiplier: 1.25 },
  { id: 'painting',  label: 'painting',       multiplier: 1.50 }
];

// Rough volume estimate (cm³) from file size (KB). Real backend will parse the geometry.
export function estimateVolumeFromFileSize(fileSizeBytes) {
  const kb = fileSizeBytes / 1024;
  const cm3 = Math.max(3, Math.min(800, kb * 0.08 + 5));
  return Math.round(cm3 * 10) / 10;
}

export function calculateQuote({ technology, materialId, layerHeight, infill, finishId, quantity, volumeCm3 }) {
  const material = (MATERIALS[technology] || []).find(m => m.id === materialId);
  const layer    = (LAYER_HEIGHTS[technology] || []).find(l => l.id === layerHeight);
  const finish   = FINISH_OPTIONS.find(f => f.id === finishId) || FINISH_OPTIONS[0];
  if (!material || !layer) return null;

  // Infill only applies to FDM; SLA & SLS are solid
  const infillFactor = technology === 'fdm' ? (0.55 + (infill / 100) * 0.6) : 1;
  const setupFee = technology === 'sls' ? 75 : 35; // SLS has higher setup (powder bed)
  const base = volumeCm3 * material.pricePerCm3 * infillFactor * layer.multiplier * finish.multiplier;
  const unit = Math.max(25, base + setupFee / Math.max(1, quantity));
  const total = unit * quantity;

  let leadMin = 2;
  let leadMax = 4;
  if (quantity > 5) { leadMin += 1; leadMax += 2; }
  if (technology === 'sla') { leadMin += 1; leadMax += 1; }
  if (technology === 'sls') { leadMin += 2; leadMax += 3; } // powder bed = longer
  if (volumeCm3 > 200) { leadMax += 2; }

  return {
    unitPrice: Math.round(unit * 100) / 100,
    totalPrice: Math.round(total * 100) / 100,
    leadMin,
    leadMax,
    volumeCm3
  };
}

export const SAMPLE_GALLERY = [
  { id: 1, title: 'Tough Reçine',        material: 'Tough Resin',     tech: 'SLA', img: 'https://images.pexels.com/photos/12268465/pexels-photo-12268465.jpeg' },
  { id: 2, title: 'Detaylı SLA',         material: 'Standart Reçine', tech: 'SLA', img: 'https://images.pexels.com/photos/6502310/pexels-photo-6502310.jpeg' },
  { id: 3, title: 'Dental Model',        material: 'Dental Reçine',   tech: 'SLA', img: 'https://images.pexels.com/photos/6528787/pexels-photo-6528787.jpeg' },
  { id: 4, title: 'PA12 (Naylon)',       material: 'PA12 Beyaz',      tech: 'SLS', img: 'https://images.pexels.com/photos/19124461/pexels-photo-19124461.jpeg' },
  { id: 5, title: 'PETG · Turuncu',      material: 'PETG',            tech: 'FDM', img: 'https://images.pexels.com/photos/17509941/pexels-photo-17509941.jpeg' },
  { id: 6, title: 'PLA · Detay',         material: 'PLA',             tech: 'FDM', img: 'https://images.pexels.com/photos/31336881/pexels-photo-31336881.jpeg' }
];
